<template>
  <div>
    <div class="tile my-4 px-3 py-4">
      <flow-group :flowGroup="flowGroup"/>
    </div>

    <div class="tile my-4">
      <loading-view :loading="initialLoading">
        <div v-if="webhook !== null">
          <form-input-header :header="trans('dashboard.integrations.flows.webhooks.webhook_for_x', {application: webhook.application, flow: webhook.flow})"/>

          <form-input type="text"
                      v-model="webhook.webhook_url"
                      :label="trans('dashboard.integrations.flows.webhooks.webhook_url')"
                      disabled/>

          <form-input v-if="webhook.hasOwnProperty('secret')"
                      type="text"
                      v-model="webhook.secret"
                      :label="trans('dashboard.integrations.flows.webhooks.webhook_secret')"/>

        </div>
        <div v-if="$can('flows.webhooks.update')" class="flex items-center my-6 mr-3 ml-1">
          <div class="ml-auto">
            <form-button
              v-if="webhook.hasOwnProperty('secret')"
              type="button"
              class="mr-6"
              @click.native="update"
              :value="trans('common.update')"
              :processing="processing"/>

            <form-button
              type="button"
              class="mr-6"
              @click.native="generateWebhook"
              :value="trans('common.generate')"
              :processing="processing"/>
          </div>
        </div>
        <div v-if="status === 0" class="alert alert-danger">
          <div class="w-full">
            <h1>{{ trans('dashboard.integrations.flows.webhooks.failed_generate_title') }}</h1>
          </div>
          <div class="w-full">
            <i> {{ trans('dashboard.integrations.flows.webhooks.failed_generate_description') }}</i>
            <br>
            <br>
            <i>{{ trans('dashboard.integrations.flows.webhooks.failed_generate_response') }}</i>
            <pre>{{ errorData }}</pre>
          </div>
        </div>
      </loading-view>
    </div>
  </div>
</template>

<script>
import {mapGetters} from 'vuex';
import Swal from "sweetalert2";
import DashboardLayout from "@/Layouts/DashboardLayout";
import IntegrationFlowLayout from "@/Layouts/IntegrationFlowLayout";
import FlowGroup from "@/components/Dashboard/FlowGroup";
import FormInputHeader from "@/components/Dashboard/FormInputHeader";
import FormButton from "@/components/Shared/Form/Button";
import FormInput from "@/components/Dashboard/FormInput.vue";

export default {
  name: 'FlowWebhooks',

  layout: [DashboardLayout, IntegrationFlowLayout],

  components: {
    FormInput,
    FormButton,
    FlowGroup,
    FormInputHeader,
  },

  data() {
    return {
      webhook: null,
      status: null,
      errorTitle: null,
      errorData: null,
      initialLoading: true,
      processing: false,
    };
  },

  async beforeMount() {
    await axios
      .get(`/api/integrations/${this.userIntegration.id}/flows/${this.userIntegrationFlow.id}/webhooks`)
      .then(({data}) => {
        this.webhook = data.data;
      });

    this.initialLoading = false;
  },

  computed: {
    ...mapGetters('flowsDetails', ['isAdmin', 'flowGroup', 'userIntegration', 'userIntegrationFlow']),
  },

  methods: {
    generateWebhook() {
      this.processing = true;

      axios
        .post(`/api/integrations/${this.userIntegration.id}/flows/${this.userIntegrationFlow.id}/webhooks`)
        .then(({data}) => {
          this.webhook = data.data;
          this.status = data.data.status;
          this.errorData = data.data.error;

          let icon = this.status ? 'success' : 'failed'
          let text = this.status ?
            this.trans('dashboard.alerts.success_generate_webhooks')
            : this.trans('dashboard.alerts.failed_generate_webhooks')

          Swal.fire({
            text: text,
            icon: icon,
            showConfirmButton: false,
            timer: 2000,
          });
        })
        .finally(() => this.processing = false)
    },

    update() {
      this.processing = true;

      axios
        .patch(`/api/integrations/${this.userIntegration.id}/flows/${this.userIntegrationFlow.id}/webhooks`, this.webhook)
        .then(({data}) => {
          this.webhook = data.data;

          Swal.fire({
            text: this.trans('dashboard.alerts.success_update_webhooks'),
            icon: 'success',
            showConfirmButton: false,
            timer: 2000,
          });
        })
        .finally(() => this.processing = false)
    }
  },
};
</script>
